import createImageIcon from './createImageIcon';
import path from './hour-glass-low.svg';

export default createImageIcon({displayName: 'HourGlassLowIcon', path});



// WEBPACK FOOTER //
// ./src/common/components/icons/HourGlassLowIcon.js